module.exports = __webpack_public_path__ + "img/xiangji.bc82053d.png";